<script setup lang="ts">
import initConfig from "../CsdPublic/initConfig";
import { allBaseUrl } from "@/config/apiDomain";
import { AppConfig } from "@/utils/constant";
import { onMounted } from "vue";

import publicStore from "@/store/publicStore";
import { CallbackID } from "@/MessageHandler";
import { setStorage } from "@/utils/storage";
import { storeToRefs } from "pinia";
import { ElMessage } from "element-plus";
// import vConsole from "vconsole";
//
// const vc = new vConsole();

const config = {
  soft_id: AppConfig.soft_id,
  os: AppConfig.os,
  curr_ver: AppConfig.curr_ver,
  wxLoginAndPayDomain: allBaseUrl.qnwApi.url,
  qnwProjectDomain: allBaseUrl.qnwApi.url,
};

initConfig(config);

onMounted(() => {
  (window as any).getCppMessage = handleCppMessage;

  //启动之后，发送指令
  (window as any).mbQuery(CallbackID.SET_TOKEN, "", null);
});

const handleTokenCmd = (data) => {
  if (!data.token) return;
  setStorage("token", data.token);
  const store = publicStore();
  const { isLogin } = storeToRefs(store);
  isLogin.value = true;
  console.log("handleTokenCmd token", data.token);
};

const handleSize = (data) => {
  // const { height, width } = data;
  //
  // const routerElement = document.getElementById("router");
  // routerElement!.style.setProperty("width", `${width}px`, "important");
  // routerElement!.style.setProperty("height", `${height}px`, "important");
};

const fixJsonString = (msg: string): string => {
  let fixedJson = msg.replaceAll(/\n/g, "\\n");
  const spTag = `P@-`;
  return fixedJson.replaceAll(spTag, `\\"`);
};

const handleCppMessage = (msg) => {
  //https://doc.weixin.qq.com/sheet/e3_AFYAlgYcABMCN07vR1bS8QsG6hm0C?scode=AJsAlAc_AAkwixt1O8AFYAlgYcABM&tab=BB08J2
  try {
    // console.log(msg);
    const fixedJson = fixJsonString(msg);
    // let fixedJson = msg.replaceAll(/\n/g, "\\n");
    // const spTag = `P@-`;
    // fixedJson = fixedJson.replaceAll(spTag, `\\"`);
    // console.log("fixedJson", fixedJson);

    const obj = JSON.parse(fixedJson);
    const cmd = obj.cmd ?? 1;
    const data = obj.data;

    if (cmd === CallbackID.SET_MODEL) {
      //model
      // handleModelCmd(data);
    } else if (cmd === CallbackID.SET_TOKEN) {
      handleTokenCmd(data);
    } else if (cmd === CallbackID.MB_SIZE) {
      handleSize(data);
    } else {
      // const { findCallbackById } = useCallbackRegistry();
      // const msgItem = findCallbackById(cmd);
      // if (!msgItem) return;
      // handleCallbackCmd(msgItem, data);
    }
  } catch (error) {
    console.log(error);
  }
};
</script>

<template>
  <router-view v-slot="{ Component }">
    <Transition name="fade">
      <component :is="Component" />
    </Transition>
  </router-view>
</template>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  color: #2c3e50;
  width: 100vw;
  height: 100vh;
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  user-select: none;
}

* {
  box-sizing: border-box;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
</style>
